import type {
  DefaultOnboardingData,
  OnboardingDoneMap,
} from '@/features/onboarding/types/onboardingData';

export const DEFAULT_ONBOARDING_DATA: DefaultOnboardingData = {
  stats: true,
  ['favourite-agent']: undefined,
  servers: [],
  ['display-name']: '',
  age: undefined,
  ['game-mode-preference']: undefined,
  ['mode-selection']: undefined,
  ['voice-chat-participation']: undefined,
  ['in-game-comm-style']: [],
  ['personality-traits']: {
    vibe: [],
    temper: [],
    playstyle: [],
  },
  languages: {
    speak: [],
    write: [],
  },
  ['play-schedule']: [],
  ['pre-game-routine']: undefined,
  ['bonding-pace']: undefined,
  notifications: undefined,
  ['nearly-done']: true,
};

export const DEFAULT_ONBOARDING_DONE: OnboardingDoneMap = {
  stats: false,
  ['favourite-agent']: false,
  servers: false,
  ['display-name']: false,
  age: false,
  languages: false,
  ['game-mode-preference']: false,
  ['mode-selection']: false,
  ['voice-chat-participation']: false,
  ['in-game-comm-style']: false,
  ['personality-traits']: false,
  ['play-schedule']: false,
  ['pre-game-routine']: false,
  ['bonding-pace']: false,
  notifications: false,
  ['nearly-done']: false,
  ['non-toxic']: false,
};
